import { Constants } from "@eagerdog/constants";
import { IEventRegisterRow } from "../../../services/helper.service.js";

export namespace ABICountryRatRace {
  export const form: IEventRegisterRow[] = [
    {
      inputs: [{
        type: "checkbox",
        multiSelect: true,
        label: Constants.show_type.country_rat_race,
        options: [
          { value: Constants.dog_class_element_level.cubs, id: Constants.dog_class_element_level.cubs },
          { value: Constants.dog_class_element_level.scouts, id: Constants.dog_class_element_level.scouts },
        ]
      }]
    },
    {
      inputs: [{
        type: "checkbox",
        multiSelect: true,
        label: Constants.show_type.country_rat_race,
        options: [
          { value: Constants.dog_class_element_level.huntsman, id: Constants.dog_class_element_level.huntsman },
        ]
      },
        {
          type: "dropdown",
          defaultValue: Constants.dog_class_section.on_leash,
          label: "Section",
          options: [
            { value: Constants.dog_class_section.on_leash, id: Constants.dog_class_section.on_leash },
            { value: Constants.dog_class_section.unleashed, id: Constants.dog_class_section.unleashed },
          ]
        }]
    },
    {
      inputs: [{
        type: "checkbox",
        multiSelect: true,
        label: Constants.show_type.country_rat_race,
        options: [
          { value: Constants.dog_class_element_level.huntsmaster, id: Constants.dog_class_element_level.huntsmaster },
        ]
      },
        {
          type: "dropdown",
          defaultValue: Constants.dog_class_section.on_leash,
          label: "Section",
          options: [
            { value: Constants.dog_class_section.on_leash, id: Constants.dog_class_section.on_leash },
            { value: Constants.dog_class_section.unleashed, id: Constants.dog_class_section.unleashed },
          ]
        }]
    },
    {
      inputs: [{
        type: "checkbox",
        multiSelect: true,
        label: Constants.show_type.country_rat_race,
        options: [
          { value: Constants.dog_class_element_level.field_master, id: Constants.dog_class_element_level.field_master },
        ]
      },
        {
          type: "dropdown",
          defaultValue: Constants.dog_class_section.on_leash,
          label: "Section",
          options: [
            { value: Constants.dog_class_section.on_leash, id: Constants.dog_class_section.on_leash },
            { value: Constants.dog_class_section.unleashed, id: Constants.dog_class_section.unleashed },
          ]
        }]
    },
  ];
}